<template>
  <div>
    <van-cell-group>
      <van-cell
        title="新增商品"
        value="去新增"
        is-link
        icon="add-o"
        to="/product/add"
        v-permission="'base-data:product:info:add'"
      />
    </van-cell-group>
    <van-cell-group style="margin-top: 0.3rem">
      <van-cell
        title="修改商品"
        value="去修改"
        is-link
        icon="edit"
        to="/product/category"
        v-permission="'base-data:product:info:modify'"
      />
    </van-cell-group>
    <van-cell-group style="margin-top: 0.3rem">
      <van-cell
        title="临期预警"
        value="去查看"
        is-link
        icon="clock-o"
        to="/product/advent"
        v-permission="'base-data:product:info:query'"
      />
    </van-cell-group>
  </div>
</template>
<script>
export default {
  name: "management",
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped></style>
